<div class="main-container">
  <div class="container">
    <div class="content-box">
      <div class="title" (click)="isH5 && location.back()">
        <span>{{ title }}</span>
      </div>
    </div>
  </div>
</div>
